var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classString},[_c('el-upload',{attrs:{"action":_vm.action,"data":_vm.params,"accept":_vm.accept,"headers":_vm.headers,"show-file-list":false,"on-success":_vm.handleSuccess,"on-error":_vm.handleError}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }